module.exports = __webpack_public_path__ + "img/2ab00a08c7c778986f192f8f32cbfa49.png";